module.exports = __webpack_public_path__ + "img/modelo.3c24e561.png";